import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

import { environment } from './../../../../../environments/environment';

@Injectable()
export class EquipmentDetailService {

  private urlPrefix: string = environment.appUrl;

  constructor(
    private http: HttpClient
  ) { }

  getDetail(id): Observable<any> {
    const url = this.urlPrefix + 'equipments/' + id + '/static';
    return this.http
      .get(url, { observe: 'response' })
      .map(
        res => {
          if (res.status === 200) {
            return res.body;
          } else {
            return Observable.throw(null);
          }
        }
      )
      .catch(
        err => {
          return Observable.throw(err);
        }
      );
  }

  getJobSummary(id): Observable<any> {
    const url = this.urlPrefix + 'equipments/' + id + '/equipment-detail';
    return this.http
      .get(url,
        {
          observe: 'response'
        })
      .map(
        res => {
          if (res.status === 200) {
            return res.body;
          } else {
            return Observable.throw(null);
          }
        }
      )
      .catch(
        err => {
          return Observable.throw(err);
        }
      );
  }

  getJobDetail(equipmentId, jobId): Observable<any> {
    const url = this.urlPrefix + 'equipments/' + equipmentId + '?jobs=' + jobId;
    return this.http
      .get(url, { observe: 'response' })
      .map(
        res => {
          if (res.status === 200) {
            return res.body;
          } else {
            return Observable.throw(null);
          }
        }
      )
      .catch(
        err => {
          return Observable.throw(err);
        }
      );
  }

  updateStatus(equipmentId): Observable<any> {
    return this.http.put(environment.appUrl + 'equipments/' + equipmentId + '/update-status', {}, {observe: 'body', withCredentials: true});
  }
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/equipment/equipment-detail/equipment-detail.service.ts